import { BlockOverrides } from 'baseui/block';
import { THEME } from '@lyon/utils/theme';
import { InputOverrides } from 'baseui/input';

export const HEADER: BlockOverrides = {
  Block: {
    style: {
      fontSize: '22px',
      fontWeight: 700,
      marginTop: '24px',
    },
  },
};

export const SUB_HEADER: BlockOverrides = {
  Block: {
    style: {
      fontSize: '18px',
      fontWeight: 600,
    },
  },
};

export const REGULAR: BlockOverrides = {
  Block: {
    style: {
      fontSize: '14px',
      fontWeight: 400,
      color: THEME.colors.mono600,
    },
  },
};

export const INPUT: InputOverrides = {
  Root: {
    style: {
      marginTop: '16px',

      [THEME.media.large]: {
        width: '296px',
        marginTop: 0,
      },
    },
  },
};
